export default __webpack_public_path__ + "static/media/keyvis_players_mob_names.4901aa46.png";